import { createAction } from 'redux-actions';

export const goNextStepAction = createAction('ADD_EQUIPMENT_NEXT_STEP');
export const goPrevStepAction = createAction('ADD_EQUIPMENT_PREV_STEP');
export const resetMaster = createAction('ADD_EQUIPMENT_RESET_MASTER');
export const toggleAddMode = createAction('ADD_EQUIPMENT_TOGGLE_ADD_MODE');
